// extracted by mini-css-extract-plugin
module.exports = {"container":"UnderConstructionPage_container__3t6Sf","status":"UnderConstructionPage_status__2N_qg","heading":"UnderConstructionPage_heading__q8L68"};